module.exports = __webpack_public_path__ + "static/img/seal-bg.9d73fcc5.jpg";